import { useState, useEffect } from 'react';



export const useImage = (src) => {
  const [hasLoaded, setHasLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [hasStartedInitialFetch, setHasStartedInitialFetch] = useState(false);

  const heap = window?.heap;

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      setHasStartedInitialFetch(true);
      setHasLoaded(false);
      setHasError(false);
    }

    // Here's where the magic happens.
    const image = new Image();
    image.src = src;
    const start = Date.now();

    const handleError = () => {
      if (isMounted) {
        const duration = Date.now() - start;
        heap.track('BYO-Image-Load', {load: 'error', 'duration': duration, 'src': src});
        setHasError(true);
      }
    };

    const handleLoad = () => {
      if (isMounted) {
        const duration = Date.now() - start;
        heap.track('BYO-Image-Load', {load: 'success', 'duration': duration, 'src': src});
        setHasLoaded(true);
        setHasError(false);
      }
    };

    image.onerror = handleError;
    image.onload = handleLoad;

    return () => {
      isMounted = false;
      image.removeEventListener('error', handleError);
      image.removeEventListener('load', handleLoad);
    };
  }, [src]);

  return { hasLoaded, hasError, hasStartedInitialFetch };
};

export default useImage;
